export default __webpack_public_path__ + "static/media/piggy-bank.9634ac17.svg";